export default (function () {
    const instance = document.querySelector('[data-module="client-type-toggle"]')

    if (!instance) return

    const inputs = instance.querySelectorAll('input[type="radio"]')
    inputs.forEach((input) => {
        input.addEventListener('change', () => {
            inputs.forEach((input) => {
                if (input.checked) {
                    document.body.dataset.clientType = input.value
                }
            })
        })
    })
})
